import { langsIdxs, dictionary, mapFields } from './dictionary';

function replaceVars(str, vars) {
    Object.entries(vars).forEach(([key, val]) => {
        str = str.replace("{" + key + "}", val);
    });

    return str;
}

export default function (lang, textKey, optionalVal, optionalVars) {

    let dictionaryKey;
    let text;

    if ((typeof textKey == 'undefined') || (textKey === 'undefined')) {
        return "";
    }

    if (typeof lang !== 'string') {
        lang = 'pt';
    }

    if (optionalVal) {
        dictionaryKey = mapFields[`${textKey}.${optionalVal}`];
    } else {
        dictionaryKey = textKey;
    }

    if (dictionaryKey in dictionary) {
        if (lang == "pt") {
            text = dictionaryKey;
        } else {
            let dictionaryEntry = dictionary[dictionaryKey];
            let langIdx = langsIdxs[lang];
            let langText = dictionaryEntry[langIdx];

            if (langText === undefined) {
                if ((dictionaryKey != 'Email') && (dictionaryKey != 'email@domain.com')) {
                    console.warn(
                        `[i18n] ${lang} language doesn't exist for the dictionary entry '${dictionaryKey}'. Returning ${dictionaryKey} as text.`
                    );
                }
                text = dictionaryKey;
            } else {
                text = langText;
            }
        }
    } else {
        if (optionalVal) {
            console.warn(
                `[i18n] textKey: ${textKey}, optionalVal: ${optionalVal}.`
            );
        } else {
            console.warn(
                `[i18n] ${dictionaryKey} doesn't exist in dictionary. Returning ${dictionaryKey} as text.`
            );
        }

        text = dictionaryKey;
    }

    if (optionalVars) {
        text = replaceVars(text, optionalVars);
    }

    return text;
}
